import React, {useCallback, useEffect, useState} from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div
      onClick={isVisible ? scrollToTop : undefined}
      style={{
        display: isVisible ? 'block' : 'none',
        position: 'fixed',
        bottom: '70px',
        right: '30px',
        cursor: 'pointer'
      }}
    >
      <ArrowUpwardIcon />
    </div>
  );
};

export default ScrollToTop;
